import RoomElement from './RoomElement'
import Arrow from '../../Rendering/Arrow'
import RoundedRect from '../../Rendering/RoundedRect'
import TextBoxRenderer from '../../Rendering/TextBoxRenderer'
import FontDefinition from '../../Fonts/FontDefinition'
import game from '../../Game/GameInstance'
import UrlExecutor from '../../Api/UrlExecutor'
import colorSchemeRepository from '../../Images/ColorSchemeRepository'

let debug = false;
let buttonMargin = 10;
let buttonSize = 12;
let arrowRenderer = new Arrow(1);
let roundedRectRenderer = new RoundedRect();
let textBoxRenderer = new TextBoxRenderer();
let fontDefinition = new FontDefinition('').size(12);

export default class ChildrenRenderer extends RoomElement
{

  constructor() {

    super(...arguments);

    // element we're currently hovering
    this.hover = null;

    // current page we're on
    this.page = 0;

    // child grid
    this.columns = 3;
    this.rows = 3;

    // calculate the total amount of pages we have
    this.maxPages = Math.ceil(this.room.data.children.length / (this.columns * this.rows));

  }

  render(ctx) {

    let mode = this.getGameView();

    arrowRenderer.setScaleFactor(this.room.zoom);
    fontDefinition.scale(this.room.zoom);

    // determine draw locations
    let groupBox = this.getChildGroupBox();
    let children = this.getChildrenBoxes(groupBox);
    let buttonBox = this.getButtonBox(groupBox, 3);

    if (debug) {
      this.debugBox(ctx, groupBox);
      this.debugBox(ctx, buttonBox);

      let i = children.length;
      while (i--) {
        this.debugBox(ctx, children[i]);
      }
    }

    // draw each child
    let i = children.length;
    let pageOffset = this.page * this.columns * this.rows;
    while (i--) {
      this.renderChild(ctx, mode, children[i], this.room.data.children[i + pageOffset], i);
      this.positionPeople(ctx, children[i], this.room.data.children[i + pageOffset], i)
    }

    // hide everyone in rooms that are invisible
    for (i = 0; i < this.room.data.children.length; i++) {
      if (i < pageOffset || i >= pageOffset + this.columns * this.rows) {

        this.room.data.children[i].personIndicator.hide();

        this.room.data.children[i].people.forEach(person => {
          person.hide();
        });

      }
    }



    // draw pagination
    this.renderPagination(ctx, buttonBox);

  }

  renderChild(ctx, mode, box, child, index) {

    // if there is no child for this position we disable it's hover location
    if (!child) {
      this.room.hoverMask.add('child-' + index).disable();
      return;
    }

    let fillColor = colorSchemeRepository.get('foregroundText');

    if (mode === 'people') {
      fillColor = this.hover === index ? colorSchemeRepository.get('roomChildActiveBackground') : colorSchemeRepository.get('roomChildBackground');
    }

    let radius = 5;
    let margin = 10;

    // render background
    ctx.beginPath();
    roundedRectRenderer.drawOn(ctx, this.scale(box.x), this.scale(box.y), this.scale(box.width), this.scale(box.height), this.scale(radius));
    ctx.fillStyle = fillColor;
    ctx.fill();

    ctx.fillStyle = colorSchemeRepository.get('foregroundText');
    textBoxRenderer.render(ctx, child.name, fontDefinition, this.scale(box.x + margin), this.scale(box.y + margin + 7), this.scale(box.width - margin * 2 - 36));

    if (child.parent.data.mode === 'business') {
        this.renderChildImage(ctx, box, child);
    }

    arrowRenderer.draw(ctx, box.x + box.width - 31 - margin, box.y + margin, 'right', this.hover === index, mode === 'people' ? 'dark' : 'white');

    this.room.hoverMask.add('child-' + index, box.x, box.y, box.width, box.height).enable().over(() => {
      this.setHover(index);
    }).out(() => {
      this.setHover(null);
    }).click(() => {
      UrlExecutor.execute(child.data.url);
    });
  }

  renderPagination(ctx, paginationBox) {

    let x = paginationBox.x;
    let y = paginationBox.y;

    let hoverShape = null;

    // amount of pixels that a user is allowed to click next to our button (as they are very small)
    let hoverThreshold = 2;

    if (this.maxPages < 2) {
      return;
    }

    ctx.beginPath();

    for (let i = 0 ; i < this.maxPages ; i++) {

      if ( i === this.page ) {
        hoverShape = { x, y };
      }
      else {
        ctx.arc(this.scale(x + buttonSize / 2), this.scale(y + buttonSize / 2), this.scale(buttonSize / 2), 0, Math.PI * 2);
      }

      this.room.hoverMask.add('page' + i, x - hoverThreshold, y - hoverThreshold, buttonSize + hoverThreshold * 2, buttonSize + hoverThreshold * 2).over(() => {

      }).out(() => {

      }).click(() => {
        this.requestPage(i);
      });

      x += buttonSize + buttonMargin;

    }

    ctx.fillStyle = colorSchemeRepository.get('roomChildBackground');
    ctx.fill();

    if (hoverShape) {
      ctx.beginPath();
      ctx.fillStyle = colorSchemeRepository.get('roomChildActiveBackground');
      ctx.arc(this.scale(hoverShape.x + buttonSize / 2), this.scale(hoverShape.y + buttonSize / 2), this.scale(buttonSize / 2), 0, Math.PI * 2);
      ctx.fill();
    }



  }


  renderChildImage(ctx, box, child) {

    let imageMargin = 25;

    let imageBox = {
      x : box.x + imageMargin,
      y : box.y + imageMargin,
      width : box.width - imageMargin * 2,
      maxHeight : box.height - imageMargin * 2
    };

    if (child.image) {

      let image = child.image.getImage()

      imageBox.height = imageBox.width / (image.width / image.height);

      if (imageBox.height > imageBox.maxHeight) {

        imageBox.height = imageBox.maxHeight;
        imageBox.width = imageBox.height / (image.height / image.width);

      }

      imageBox.x = box.x + (box.width - imageBox.width) / 2;
      imageBox.y = box.y + ((box.height - imageBox.height) / 2) + 20;
      try {
        ctx.drawImage(child.image.getImage(), this.scale(imageBox.x), this.scale(imageBox.y), this.scale(imageBox.width), this.scale(imageBox.height));
      } catch (e) {
        console.warn(e)
      }

    }

  }




  requestPage(page) {
    this.page = page;
    this.room.needsRendering = true;
  }

  requestNextPage() {

    if (!this.isValidPage(this.page + 1)) {
      return this.requestPage(0);
    }
    this.requestPage(this.page + 1);

  }

  requestPreviousPage() {

    if (!this.isValidPage(this.page - 1)) {
      return this.requestPage(this.maxPages - 1);
    }
    this.requestPage(this.page - 1);

  }

  isValidPage(page) {

    return page >= 0 && page < this.maxPages;

  }

  getChildrenBoxes(groupBox) {

    let columns = this.columns;
    let rows = this.rows;

    let hMargin = 10;
    let vMargin = 10;

    let i = rows * columns;
    let boxes = [];

    let width = (groupBox.width - hMargin * (columns - 1)) / columns;
    let height = (groupBox.height - vMargin * (rows - 1)) / rows;

    let x = 0;
    let y = 0;

    while (i--) {

      boxes.push({
        width,
        height,
        x : x + groupBox.x,
        y : y + groupBox.y,
      });

      x += width + hMargin;

      if (x > groupBox.width) {
        x = 0;
        y += height + vMargin;
      }

    }

    return boxes;

  }

  getButtonBox(groupBox, buttons) {

    let marginTop = 30;

    let width = (buttonSize + buttonMargin) * buttons - buttonMargin;
    let height = buttonSize;
    let y = groupBox.y + groupBox.height + marginTop;
    let x = groupBox.x + (groupBox.width - width) / 2;

    return {
      x,
      y,
      width,
      height
    };

  }

  getChildGroupBox() {

    let x = 50;
    let y = 90;

    return {
      x,
      y,
      width : this.roomWidth() - x * 2,
      height : this.roomHeight() - y - 125
    };

  }

  setHover(x) {
    this.hover = x;
    this.room.needsRendering = true;
  }

  positionPeople(ctx, box, child, index) {

    if (!child) {
      return ;
    }

    if (game.view === 'speakers' ) {
      child.personIndicator.hide();

      this.room.hoverMask.add('business-indicator-' + index).disable();

      child.people.forEach(person => {
        person.hide();
      });

      return;
    }

    let margin = 6;
    let size = 32;

    let marginTop = (box.height - size) / 2;
    let marginLeft = 10;

    let maxPeople = 4;

    let childrenBox = {
      x : box.x,
      y : box.y + 60,
      width : maxPeople * (size + margin) - margin,
      height : size
    };

    childrenBox.x = box.x + (box.width - childrenBox.width) / 2;

    let cnt = child.people.length;

    if (cnt > maxPeople) {

      // show indicator!
      // game.layers.people.push(personIndicator);

      child.personIndicator.x = this.room.x + childrenBox.x + size / 2 + (maxPeople - 1) * (size + margin);
      child.personIndicator.y = this.room.y + childrenBox.y + size / 2;
      child.personIndicator.setCount(cnt - maxPeople + 1);
      child.personIndicator.show();

      this.room.hoverMask.add('business-person-' + index + '-' + (maxPeople - 1)).disable();

      this.room.hoverMask.add('business-indicator-' + index, childrenBox.x + (maxPeople - 1) * (size + margin), childrenBox.y, size, size).enable().over(() => {
        let personSize = 32;

        let coord = game.mapCoordToScreenCoord(this.room.x + childrenBox.x + childrenBox.width - personSize, this.room.y + childrenBox.y);

        game.hoverNameList.setPeople(child.people.slice(maxPeople - 1));

        // center
        game.hoverNameList.x = coord.x + personSize / 2;
        // bottom
        game.hoverNameList.y = coord.y + personSize;
        game.hoverNameList.show();

        let height = game.hoverNameList.height;
        let width = game.hoverNameList.width;

        this.room.hoverMask.add('hovernamelist', childrenBox.x + (maxPeople - 1) * (size + margin) + (personSize - width) / 2, childrenBox.y, width, height + personSize)
          .out(() => {

            game.hoverNameList.hide();
            this.room.hoverMask.remove(/hovernamelist/);

          })
          .click((x, y) => {
            y -=  childrenBox.y;
            game.hoverNameList.click(x, y);
          })
          .over(() => {
            console.log('hover');
          });


      }).out(() => {

      }).click(() => {

      });

      cnt = maxPeople - 1;

    }
    else {

      this.room.hoverMask.add('business-indicator-' + index).disable();
      child.personIndicator.hide();

    }

    for(let i = 0; i < cnt; i++) {

      let person = child.people[i];

      person.x = this.room.x + childrenBox.x + size / 2 + i * (size + margin);
      person.y = this.room.y + childrenBox.y + size / 2;
      person.show();

      this.room.hoverMask.add('business-person-' + index + '-' + i, childrenBox.x + i * (size + margin),  childrenBox.y, size, size).enable().over(() => {
        game.setToolTipText(person.x, person.y + 16, person.getName(), true);
      }).out(() => {
        game.setToolTipText(null);
      }).click(() => {
        UrlExecutor.execute(person.data.url);
      });

    }

    for (let i = cnt; i < maxPeople; i++) {
      this.room.hoverMask.add('business-person-' + index + '-' + i).disable();
    }

    // these people fall outside the boat
    for (let i = cnt; i < child.people.length; i++) {

      let person = child.people[i];
      person.hide();

    }


  }



}
